import React, { useEffect, useState } from "react";
import { Typography, Spin } from 'antd';
import SidebarLayoutConsumer from "../Administrator/SidebarLayoutConsumer";
import Reports from "./Reports";
const { Title } = Typography;

const ConsumerReports = () => {
    const [loading, setLoading] = useState(false);
    const consumerId = localStorage.getItem("ConsumerUserId");

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <Spin spinning={loading}>
            <SidebarLayoutConsumer>
                <div>
                    <Reports consumerId={consumerId} />
                </div>

            </SidebarLayoutConsumer >
        </Spin >
    );
};

export default ConsumerReports;
